import { Fancybox } from '@fancyapps/ui'

export default (_, inject) => {
  inject('fancybox', Fancybox)
}
